import { IXetThucTapRequest } from "../../../model/request/xet-thuc-tap/IXetThucTapRequest";
import { IXetThucTapThamSoXetRequest } from "../../../model/request/xet-thuc-tap/IXetThucTapThamSoXetRequest";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eXetThucTapActionsObj = {

    SHOW_THAM_SO_MODAL: 0,
    CLOSE_THAM_SO_MODAL: undefined,
    
    XET_START: {} as IXetThucTapThamSoXetRequest,
    XET_SUCCESS: undefined,
    XET_ERROR: "",

    XET_THEO_MON_NGHIEP_VU_START: {} as IXetThucTapRequest,
    XET_THEO_MON_NGHIEP_VU_SUCCESS: undefined,
    XET_THEO_MON_NGHIEP_VU_ERROR: "",

    CLOSE_PROCESSING_MODAL: undefined,

    CHANGE_FILTER_LOP: {} as {
        id_he: number;
        id_khoa: number;
        khoa_hoc: number;
        id_chuyen_nganh: number;
        id_lop: number;
    },
}

export const eXetThucTapActionIds = generateActionTypeIds(eXetThucTapActionsObj, "XET_THUC_TAP");
export type IXetThucTapActionTypes = IGenericActionType<typeof eXetThucTapActionsObj, "XET_THUC_TAP">;